export const ProjectActionTypes = {
  SET_PROJECTS: "@@project/SET_PROJECTS",
  SET_PROJECTS_ERROR: "@@project/SET_PROJECTS_ERROR",
  SET_SELECTED_PROJECT: "@@project/SET_SELECTED_PROJECT",
}; 